import { createSlice } from "@reduxjs/toolkit";
import { fetchInventoryStockTransferPendingApproval } from "./thunk";

interface initialStateType {
  StockTransfertPendingApprovalList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: initialStateType = {
  StockTransfertPendingApprovalList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const InventoryStockTransferApprovalLogSlice = createSlice({
  name: "InventoryItemRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInventoryStockTransferPendingApproval.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInventoryStockTransferPendingApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.StockTransfertPendingApprovalList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchInventoryStockTransferPendingApproval.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch StockTransfer List";
      });
  },
});


export default InventoryStockTransferApprovalLogSlice.reducer;
